module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-300italic.4df3289.woff";